import { getWorkspaceId } from "./getCredentials";
import { requestFromToggl } from "./requestFromToggl";

export function getTimeEntriesOfClient(clientId, successCb, failCb) {
  const url = `https://api.track.toggl.com/reports/api/v3/workspace/${getWorkspaceId()}/search/time_entries`;
  const method = "POST";
  const body = {
    // billable: "boolean",
    client_ids: [clientId],
    // description: "string",
    end_date: "2023-09-30",
    // first_id: "integer",
    // first_row_number: "integer",
    // first_timestamp: "integer",
    // group_ids: ["integer"],
    // grouped: "boolean",
    // hide_amounts: "boolean",
    // max_duration_seconds: "integer",
    // min_duration_seconds: "integer",
    order_by: "date",
    order_dir: "DESC",
    // page_size: "integer",
    // postedFields: ["string"],
    // project_ids: ["integer"],
    // rounding: "integer",
    // rounding_minutes: "integer",
    // startTime: "string",
    start_date: "2022-09-30",
    // tag_ids: ["integer"],
    // task_ids: ["integer"],
    // time_entry_ids: ["integer"],
    // user_ids: ["integer"],
  };

  requestFromToggl(url, method, body, successCb, failCb);
}
